<template>
  <div class="body">
    <img class="bodyBgc" :src="mediaBgc" alt="背景图" />
    <div class="wrap">
      <p class="wrapTitle">合作媒体</p>
      <p class="wrapDesc">PARTNER MEDIAS</p>
      <ul class="wrapNav">
        <li class="wrapNavList" v-for="(item, index) in mediaList" :key="index">
          <img :src="item" alt="媒体" />
        </li>
      </ul>
      <img
        class="wrapMore"
        @click="toMore()"
        src="https://p0.ssl.qhimg.com/t014dd2729b5fb029e9.png"
        alt="查看更多"
      />
    </div>
  </div>
</template>

<script setup>
import { getMedia } from '@/api/2023/index.js'
import { onBeforeMount, ref } from 'vue'
const mediaList = ref([])
const mediaBgc = ref('')
onBeforeMount(async () => {
  await fetch()
})
function fetch() {
  getMedia()
    .then((res) => {
      const data = res.data.data.media
      mediaBgc.value = data.background
      mediaList.value = data.list.slice(0, 27)
    })
    .catch((err) => {
      console.log('失败', err)
    })
}
function toMore() {
  window.open('https://isc.360.com/2022/logo1.html')
}
</script>

<style lang="scss" scoped>
.body {
  position: relative;
  width: 100%;
  height: 795px;
  padding: 40px 0px 0px;
  overflow: hidden;
  &Bgc {
    width: auto;
    height: 100%;
    position: absolute;
    top: 0;
    left: 40%;
    transform: translateX(-40%);
  }
}
.wrap {
  text-align: center;
  margin: auto;
  &Title {
    font-size: 18px;
    font-weight: bold;
    line-height: 26px;
    color: #3d3d3d;
    margin: 0;
  }
  &Desc {
    font-size: 12px;
    line-height: 26px;
    color: #3d3d3d;
    margin: 4px 0 40px;
  }
  &Nav {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-wrap: wrap;
    width: 394px;
    height: 532px;
    margin: auto;
    &List {
      list-style: none;
      width: 126px;
      height: 52px;
      line-height: 52px;
      background-color: #fff;
      img {
        width: 90px;
        height: 36px;
      }
    }
  }
  &More {
    display: block;
    width: 130px;
    height: 36px;
    line-height: 36px;
    margin: 40px auto 60px;
  }
}
</style>
